'use strict';

import { createPatch } from 'rfc6902';

export default class PatchService {
  /**
   * Create Patch
   * @param  {Resource} original
   * @param  {Object}   modified
   * @return {Patch[]}
   */
  diff(original, modified) {
    return createPatch(original, modified);
  }
  /**
   * Save Patch
   * @param  {Resource} Resource
   * @param  {Object}   modified
   * @return {Promise}
   */
  save(Resource, modified) {
    return Resource.get({id: modified._id}).$promise
      .then((original) => Resource.patch({id: original._id}, this.diff(original.toJSON(), modified)));
  }
}



// WEBPACK FOOTER //
// ./client/components/storage/patch.service.js